import { themeGet } from '@styled-system/theme-get'
import { Button, Flex } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

const FlexContainer = styled(Flex)`
  gap: ${themeGet('space.3')};
`

function handleButtonClick(url, openInNewTab = true) {
  // istanbul ignore else
  if (typeof window === 'object') {
    window.open(url, openInNewTab ? '_blank' : '_self')
  }
}

const MerchModuleActions = ({
  actions,
  hasContentAbove,
  isDark,
  justifyContent,
  primaryCallToAction,
  secondaryCallToAction,
}) => {
  if (actions) {
    return (
      <Flex justifyContent={justifyContent} mt={hasContentAbove ? 3 : undefined}>
        {actions}
      </Flex>
    )
  }

  if (primaryCallToAction || secondaryCallToAction) {
    const { ariaLabel, label, longUrl, url, openInNewTab } = primaryCallToAction || {}

    const {
      ariaLabel: secAriaLabel,
      label: secLabel,
      longUrl: secLongUrl,
      openInNewTab: secOpenInNewTab,
      url: secUrl,
    } = secondaryCallToAction || {}

    return (
      <FlexContainer flexWrap='wrap' justifyContent={justifyContent} mt={hasContentAbove ? 3 : undefined}>
        {primaryCallToAction && (
          <Button
            aria-label={ariaLabel}
            variation={isDark ? 'white' : 'fill'}
            onClick={() => handleButtonClick(url || longUrl, openInNewTab)}
          >
            {label}
          </Button>
        )}
        {secondaryCallToAction && (
          <Button
            aria-label={secAriaLabel}
            bg={isDark ? 'background.base' : undefined}
            variation='subtle'
            onClick={() => handleButtonClick(secUrl || secLongUrl, secOpenInNewTab)}
          >
            {secLabel}
          </Button>
        )}
      </FlexContainer>
    )
  }

  return null
}

export default MerchModuleActions
